<template>
  <div class="layout">
    <LayoutHeader :has-bg-color="true" />
    <Back />
    <slot />
  </div>
</template>

<script>
import LayoutHeader from '@/layout/header';
import Back from '@/layout/back';
export default {
  name: 'Layout',
  components: {LayoutHeader, Back},
};
</script>
